import bilditBIcon from '../../assets/images/bildit-b-icon.png';
import bilditLogo from '../../assets/images/BILDIT_logo.svg';
import '../../assets/css/Onboarding.css';

const HOME_URL = 'https://www.bildit.co';

/**
 * Top nav for verification / post-signup screens (BWC-4793).
 */
function OnboardingNav() {
  return (
    <nav className="onboarding-nav" aria-label="BILDIT">
      <a
        href={HOME_URL}
        className="onboarding-nav-brand"
        target="_blank"
        rel="noopener noreferrer"
      >
        <img
          src={bilditBIcon}
          alt=""
          className="onboarding-nav-mark"
        />
        <img
          src={bilditLogo}
          alt="BILDIT"
          className="onboarding-nav-wordmark"
        />
      </a>
    </nav>
  );
}

export default OnboardingNav;
